import {createApp} from 'vue'
import ActiveGroups from './ActiveGroups'

const el = '.kb-component--active-groups'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((ActiveGroupsDOM) => {
            const props = {
                guid: ActiveGroupsDOM.dataset.guid,
                spotCard: ActiveGroupsDOM.dataset.spotCard ? JSON.parse(ActiveGroupsDOM.dataset.spotCard) : null,
            }
            const component = createApp(ActiveGroups, props).use(Store)
            component.mount(ActiveGroupsDOM)
        })
    }
}